import React, { useEffect, useState } from "react";
import "./Gallery.css";

export default function ProductList() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    const timer = setTimeout(() => {
      fetch("https://thbackend-lqde.onrender.com/api/products")
        .then((response) => response.json())
        .then((data) => {
          setProducts(data);
          setLoading(false); // Hide loader after data is fetched
        })
        .catch((error) => {
          console.error("Error fetching products:", error);
          setLoading(false);
        });
    }, 1500); // Show loader for at least 500ms

    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="shop-container">
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        <div className="product-grid">
          {products.length > 0 ? (
            products.map((product) => (
              <div key={product.id} className="product-card">
                <img
                  src={product.image ? product.image : "/placeholder.png"}
                  alt={product.name}
                  className="product-image1"
                />
                <h3 className="product-name">{product.name}</h3>
                <div className="product-info">
                  <p className="product-price">₹ {product.price}</p>
                  <p className="product-weight">{product.weight} grams</p>
                </div>
              </div>
            ))
          ) : (
            <p className="no-products">No products found</p>
          )}
        </div>
      )}
    </section>
  );
}
